import { poll } from '../../server';
import { variation } from '../../api';
import { logAPIError } from '../logger';
import { CHECK_PREVIEW_ATTEMPTS_NUMBER, CHECK_PREVIEW_PAUSE } from './constants';

const checkVariationReady =
    (app, metricApi) =>
    async (
        variationId,
        flowName,
        pollingInterval = CHECK_PREVIEW_PAUSE,
        pollingRetriesAmount = CHECK_PREVIEW_ATTEMPTS_NUMBER
    ) => {
        const checkVariationReadyAction = variation.previewReady.bind(null, {
            variationId,
            flowName,
        });

        try {
            const isReady = await poll({
                action: checkVariationReadyAction,
                exitCondition: (response) => !!response,
                pollingInterval,
                pollingRetriesAmount,
            });

            if (!isReady) {
                metricApi.count(`${app}.action.buy-variation.preview-ready.exceeded`);
            }

            return isReady;
        } catch (e) {
            logAPIError(e, {
                message: `Error while polling publish status for ${variationId} for ${flowName}`,
                variationId,
            });
        }

        return false;
    };

export default checkVariationReady;
